<template>
<div class="panel panel-offset" >
    <div class="panel-heading green-bg">
        <h3 class="panel-title">{{evaluationTitle}}</h3>
    </div>
    <div class="panel-body">
        <tabs>
            <tab v-for="evaluation in evaluationList" v-if="!(currentUserEvaluationSourceEnum.includes(evaluation.evaluationSourceId))" :key="evaluation.evaluationSourceId" v-bind:header="evaluation.sourceName">
                <div v-bind:style="evaluation.style" >
                    <div class="form-group" v-if="!isLimitedEval">
                        <label class="col-md-2 control-label">Eligibility</label>
                        <div class="col-md-2" v-for="eligibilityType in eligibilityTypeList" v-if="eligibilityType.eligibilityId === evaluation.eligibilityId">
                            <span class="form-control">{{ eligibilityType.description }}</span>
                        </div>
                        <div v-show="isEligible(evaluation.evaluationSourceId) && evaluation.evaluationSourceId === 4" class="col-md-5">
                            <div style="padding-top:0px">
                                <label class="inline">Eligible by NRHP Keeper: </label>
                                <span class="form-control inline">{{ isKeeper ? 'Yes' : 'No' }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" v-if="evaluation.evaluationSourceId === 4">
                        <label class="col-md-2 control-label">Concurred</label>
                        <div class="col-md-2" v-if="concurredList.find(x => x.concurredId === evaluation.concurredId)">
                            <span class="form-control">{{concurredList.find(x => x.concurredId === evaluation.concurredId).description}}</span>
                        </div>
                    </div>
                    <div v-show="isEligible(evaluation.evaluationSourceId)" v-if="!isLimitedEval">
                        <div class="form-group">
                            <label class="col-md-2 control-label">Criteria Met</label>
                            <div disabled class="col-md-8">
                                <div v-if="evaluation.isEligibleA" class="checkbox-inline">
                                    <label class="form-control">A</label>
                                </div>
                                <div v-if="evaluation.isEligibleB" class="checkbox-inline">
                                    <label class="form-control">B</label>
                                </div>
                                <div v-if="evaluation.isEligibleC" class="checkbox-inline">
                                    <label class="form-control">C</label>
                                </div>
                                <div v-if="evaluation.isEligibleD" class="checkbox-inline">
                                    <label class="form-control">D</label>
                                </div>
                            </div>

                        </div>
                        <div v-if="evaluation.isEligibleB" class="form-group">
                            <label class="col-md-2 control-label">Associated Person</label>
                            <div  class="col-md-3">
                                <span class="form-control">{{evaluation.associatedPerson}}</span>
                            </div>
                        </div>
                        <div v-if="canContribute">
                            <div class="form-group">
                                <label class="col-md-2 control-label">Contributing Component: </label>
                                <div class="col-md-2">
                                    <span class="form-control">{{ evaluation.isContributing ? 'Contributing' : 'Not Contributing' }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label">Effect</label>
                            <div class="col-md-2" v-for="effect in effectList" v-if="effect.effectId === evaluation.effectId">
                                <span class="form-control">{{effect.description}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" v-if="isLimitedEval">
                        <label class="col-md-2 control-label">Effect</label>
                        <div class="col-md-2" v-for="effect in effectList" v-if="effect.effectId === evaluation.effectId">
                            <span class="form-control">{{effect.description}}</span>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Discuss Condition and Integrity</label>
                        <div class="col-md-10">
                            <span class="form-control" style="overflow-y:scroll; resize:both; width:750px; min-height: 100px; white-space: pre-line;">{{evaluation.justification}}</span>
                        </div>
                    </div>
                </div>
            </tab>
            <tab v-for="evaluation in evaluationList" v-if="(currentUserEvaluationSourceEnum.includes(evaluation.evaluationSourceId))" :key="evaluation.evaluationSourceId" v-bind:header="evaluation.sourceName">
                <div v-bind:style="evaluation.style" >
                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('eligibility') }" v-if="!isLimitedEval">
                        <label class="col-md-2 control-label">Eligibility</label>
                        <div class="col-md-2">
                            <select name="eligibility" v-model="evaluation.eligibilityId" class="form-control" :disabled="canContribute" v-validate="evalValidationRules(evaluation.evaluationSourceId)">
                                <option disabled value ="">Select a value</option>
                                <option v-for="eligibilityType in eligibilityTypeList" v-bind:value="eligibilityType.eligibilityId">
                                    {{eligibilityType.description}}
                                </option>
                            </select>
                            <span v-show="errors.has('eligibility')" class="has-error">Eligibility is required</span>
                        </div>
                        <div v-if="isEligible(evaluation.evaluationSourceId) && evaluation.evaluationSourceId === 4" class="col-md-4">
                            <div class="checkbox checkbox-inline" style="padding-top:0px">
                                <input type="checkbox" id="isKeeper" value="keeper" v-model="isKeeper">
                                    <label for="isKeeper">Eligible by NRHP Keeper</label>
                                </input>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" v-if="evaluation.evaluationSourceId === 4" v-bind:class="{ 'has-error': errors.has('concurred') }">
                        <label class="col-md-2 control-label">Concurred</label>
                        <div class="col-md-3">
                            <select name="concurred" v-model="evaluation.concurredId" class="form-control" v-validate="'required'">
                                <option disabled value ="">Select a value</option>
                                <option v-for="concurredType in concurredList" v-bind:value="concurredType.concurredId" :key="concurredType.concurredId">
                                    {{concurredType.description}}
                                </option>
                            </select>
                            <span v-show="errors.has('concurred')" class="has-error">Concurred is required</span>
                        </div>
                    </div>
                    <div v-if="!isLimitedEval && isEligible(evaluation.evaluationSourceId)">
                        <div class="form-group" v-bind:class="{ 'has-error': errors.has('criteria_group') }">
                            <label class="col-md-2 control-label">Criteria Met</label>
                            <div disabled class="col-md-8">
                                <div class="checkbox checkbox-inline">
                                    <input :disabled="canContribute" type="checkbox" v-model="evaluation.isEligibleA" v-bind:id="evaluation.sourceName+'eligA'" v-bind:value="evaluation.sourceName+'A'"
                                    name="criteria_group" v-validate="isEligible(evaluation.evaluationSourceId) ? evalValidationRules(evaluation.evaluationSourceId) : ''" >
                                        <label v-bind:for="evaluation.sourceName+'eligA'">A</label>
                                    </input>
                                </div>
                                <div class="checkbox checkbox-inline">
                                    <input name="criteria_group" :disabled="canContribute" type="checkbox" v-model="evaluation.isEligibleB" v-bind:id="evaluation.sourceName+'eligB'" v-bind:value="evaluation.sourceName+'B'">
                                        <label v-bind:for="evaluation.sourceName+'eligB'">B</label>
                                    </input>
                                </div>
                                <div class="checkbox checkbox-inline">
                                    <input name="criteria_group" :disabled="canContribute" type="checkbox" v-model="evaluation.isEligibleC" v-bind:id="evaluation.sourceName+'eligC'" v-bind:value="evaluation.sourceName+'C'">
                                        <label v-bind:for="evaluation.sourceName+'eligC'">C</label>
                                    </input>
                                </div>
                                <div class="checkbox checkbox-inline">
                                    <input name="criteria_group" :disabled="canContribute" type="checkbox" v-model="evaluation.isEligibleD" v-bind:id="evaluation.sourceName+'eligD'" v-bind:value="evaluation.sourceName+'D'">
                                        <label v-bind:for="evaluation.sourceName+'eligD'">D</label>
                                    </input>
                                </div>
                                <div>
                                    <span v-show="errors.has('criteria_group')" class="has-error">Criteria is required</span>
                                </div>
                            </div>

                        </div>
                        <div v-if="evaluation.isEligibleB" class="form-group" v-bind:class="{ 'has-error': errors.has('associatedPerson') }">
                            <label class="col-md-2 control-label">Associated Person</label>
                            <div  class="col-md-3">
                                <input name="associatedPerson" type="text" class="form-control" v-model="evaluation.associatedPerson" v-validate="evaluation.isEligibleB ? evalValidationRules(evaluation.evaluationSourceId) : '' "/>
                                <span v-show="errors.has('associatedPerson')" class="has-error">Associated Person is required</span>
                            </div>
                        </div>
                        <div v-if="canContribute" v-bind:class="{ 'has-error': errors.has('isContributing') }">
                            <div class="form-group">
                                <label class="col-md-2 control-label">Contributing Component</label>
                                <div class="col-md-2">
                                    <select name="isContributing" class="form-control" v-model="evaluation.isContributing" v-validate="canContribute ? evalValidationRules(evaluation.evaluationSourceId) : '' ">
                                        <option value="">Select a value</option>
                                        <option value=true>Contributing</option>
                                        <option value=false>Not Contributing</option>
                                    </select>
                                    <span v-show="errors.has('isContributing')" class="has-error">Contrib Component is required</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group" v-bind:class="{ 'has-error': errors.has('effect') }">
                            <label class="col-md-2 control-label">Effect</label>
                            <div class="col-md-2">
                                <select name="effect" class="form-control" v-model="evaluation.effectId" v-validate="isEligible(evaluation.evaluationSourceId)? evalValidationRules(evaluation.evaluationSourceId) : '' ">
                                    <option disabled value="">Select a value</option>
                                    <option v-for="effect in effectList" v-bind:value="effect.effectId">
                                        {{effect.description}}
                                    </option>
                                </select>
                                <span v-show="errors.has('effect')" class="has-error">Effect is required</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('effect') }" v-if="isLimitedEval">
                        <label class="col-md-2 control-label">Effect</label>
                        <div class="col-md-2">
                            <select name="effect" class="form-control" v-model="evaluation.effectId" v-validate="isEligible(evaluation.evaluationSourceId)? evalValidationRules(evaluation.evaluationSourceId) : '' ">
                                <option disabled value="">Select a value</option>
                                <option v-for="effect in effectList" v-bind:value="effect.effectId">
                                    {{effect.description}}
                                </option>
                            </select>
                            <span v-show="errors.has('effect')" class="has-error">Effect is required</span>
                        </div>
                    </div>
                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('justification') }">
                        <label class="col-md-2 control-label">Discuss Condition and Integrity</label>
                        <div class="col-md-10">
                            <textarea name="justification" class="form-control" v-model="evaluation.justification" style="width:750px" rows="6" v-validate="evalValidationRules(evaluation.evaluationSourceId)" />
                            <span v-show="errors.has('justification')" class="has-error">Condition and Integrity are required</span>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-6 col-md-offset-2">
                            <validationResultDisplay :validationResult="validationResult"></validationResultDisplay>
                        </div>
                    </div>
                    <!-- <div class="form-group">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <div v-show="errors.items.length > 0">
                                <span class="has-error">Please complete evaluation form</span>
                            </div>
                        </div>
                    </div> -->
                    <div class="form-group">
                        <button class="col-md-2 btn btn-primary" v-on:click="saveEligibility(evaluation.evaluationSourceId)">Save Evaluation</button>
                    </div>
                </div>
            </tab>
        </tabs>
    </div>
</div>
</template>

<script>
import loggingService from '@/services/util/loggingService'
import evaluationService from '@/services/siteForm/evaluationService'
import validationResultDisplay from '@/components/ValidationResultDisplay.vue'
import culturalResourceRecordingService from '@/services/culturalResourceRecordingService'
import workflowService from '@/services/workflowService'

import workflowInstance from '@/components/workflow/WorkflowInstance.vue'
import workflowHistory from '@/components/workflow/WorkflowHistory.vue'
import workflowSubmit from '@/components/workflow/workflowSubmit.vue'
import roleService from '@/services/roleService.js'
import { mapState } from 'vuex'

import { tab, tabs } from 'vue-strap'

export default {
    name: 'siteFormEvaluation',
    components: {
        tab,
        tabs,
        validationResultDisplay,
        workflowHistory,
        workflowInstance,
        workflowSubmit
    },
    data: function () {
        return {
            isLoading: false,
            isDebug: false,
            eligibilityTypeList: [],
            effectList: [],
            eligibilityEnum: {},
            workflowInstance: {},
            currentWorkflowStatus: {},
            nextWorkflowStatusList: [],
            workflowInstanceStatusDtoList: null,
            evaluationList: [],
            isKeeper: false,
            disabledStyle: {
                'pointer-type': 'None',
                'opacity': 0.4
            },
            validationResult: [],
            sourceSubmitStatus: {
            },
            headList: [],
            crrWfsEnum: culturalResourceRecordingService.WorkflowStatusEnum,
            concurredList: evaluationService.ConcurredList
        }
    },
    props: {
        head: {},
        culturalResource: {},
        onEvaluationSave: {},
        isQaqc: { default: false },
        isConsultantSubmitted: { default: true },
        isAgencySubmitted: { default: true },
        hasAgencyAccess: { default: false },
        hasShpoAccess: { default: false },
        isConditionReport: { default: false },
        isInternalReview: { default: false },
        isNormalization: { default: false }
    },
    mounted () {
        this.log(`Mounted with head ${this.head.siteName} resource ${this.culturalResource.siteName}`)
        this.loadData().then(result => {
            this.log('Done Loading Data')
        })
    },
    computed: {
        canContribute: function () {
            return this.head.culturalResourceId !== this.culturalResource.culturalResourceId
        },
        evaluationTitle: function () {
            return ((this.canContribute) ? 'Contributing Component to ' : 'Evaluation for ') + this.head.siteName
        },
        isLimitedEval: function () {
            return this.isConditionReport || this.isInternalReview
        },
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        currentUserEvaluationSourceEnum: function () {
            // set up consultant, agency, and shpo role lists
            var adminRoleList = [roleService.RoleEnum.Administrator, roleService.RoleEnum.ShpoAdministrator]
            var consultantRoleList = [roleService.RoleEnum.ConsultantUser]
            var agencyRoleList = [roleService.RoleEnum.BlmUser]
            var shpoRoleList = [
                roleService.RoleEnum.ShpoAdministrator,
                roleService.RoleEnum.ShpoCrApprovingUser,
                roleService.RoleEnum.ShpoCrDataEntryUser,
                roleService.RoleEnum.ShpoRcAdministrator,
                roleService.RoleEnum.ShpoRcApprovingUser,
                roleService.RoleEnum.ShpoRcDataEntryUser
            ]
            //add agency/shpo role to consultantRoleList if "isConsultantSubmitted" === false and has agency/shpo access
            if (!this.isConsultantSubmitted) {
                if (this.hasAgencyAccess) {
                    consultantRoleList.push(roleService.RoleEnum.BlmUser)
                }
                if (this.hasShpoAccess) {
                    consultantRoleList = shpoRoleList.concat(consultantRoleList)
                }
            }
            //add shpo role to agencyRoleList if "isAgencySubmitted" === false and has shpo access
            if (!this.isAgencySubmitted) {
                if (this.hasShpoAccess) {
                    agencyRoleList = shpoRoleList.concat(agencyRoleList)
                }
            }
            if (this.shpoUserDto && !this.isQaqc) {
                // check current user's roleList is in one of the above role lists, assign appropriate Evaluation Source Enum
                if (this.shpoUserDto.roleList.find(role => { return adminRoleList.includes(role) })) {
                    // if user is site administrator, assign all source enums
                    return [
                        evaluationService.EvaluationSourceEnum.Consultant,
                        evaluationService.EvaluationSourceEnum.Agency,
                        evaluationService.EvaluationSourceEnum.SHPO,
                        evaluationService.EvaluationSourceEnum.Current
                    ]
                } else if (this.shpoUserDto.roleList.find(role => { return consultantRoleList.includes(role) })) {
                    // return empty [] if consultant submitted form
                    return (this.isConsultantSubmitted ? [] : [ evaluationService.EvaluationSourceEnum.Consultant ])
                } else if (this.shpoUserDto.roleList.find(role => { return agencyRoleList.includes(role) })) {
                    // return empty [] if agency submitted form
                    return (this.isAgencySubmitted ? [] : [ evaluationService.EvaluationSourceEnum.Agency ])
                } else if (this.shpoUserDto.roleList.find(role => { return shpoRoleList.includes(role) })) {
                    return [ evaluationService.EvaluationSourceEnum.SHPO, evaluationService.EvaluationSourceEnum.Current ]
                } else {
                    return []
                }
            } else {
                return []
            }
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Site Evaluation', message)
        },
        isEligible (evaluationSourceId) {
            var evaluation = this.evaluationList.find(x => { return x.evaluationSourceId === evaluationSourceId })
            return evaluation.eligibilityId === evaluationService.EligibilityEnum.Eligible
        },
        loadEvaluations (crrId) {
            var searchDto = {culturalResourceRecordingId: crrId, associatedCulturalResourceId: this.head.culturalResourceId}
            return evaluationService.search(this.$http, searchDto).then(response => {
                if (response.data.length > 0) {
                    this.log('Found evaluations: ' + response.data.length)
                    this.evaluationList = response.data.map(x => {
                        x.sourceName = evaluationService.sourceName(x.evaluationSourceId)
                        return x
                    })
                    this.log('Evaluation length: ' + this.evaluationList.length)
                    this.log('Checking workflow status: ' + this.currentWorkflowStatus.workflowStatusId)
                    // check current workflow status and create new agency/shpo evaluation list if necessary
                    switch (this.currentWorkflowStatus.workflowStatusId) {
                    // if currentWorkflowStatus is Pending Agency Approval,
                    // create new Agency eval only if current user has agency role and evaluationList has no existing Agency evaluation
                    case (this.crrWfsEnum.PendingAgencyApproval):
                        this.checkSourceAndCreateEvaluation(evaluationService.EvaluationSourceEnum.Agency)
                        break
                    // if currentWorkflowStatus is Pending SHPO Approval,
                    // create new SHPO eval only if current user has shpo role and evaluationList has no existing shpo evaluation
                    case (this.crrWfsEnum.PendingSHPOApproval):
                        if (!this.checkSourceAndCreateEvaluation(evaluationService.EvaluationSourceEnum.SHPO)) {
                            // if shpo eval is not created from the above, run the below
                            if (!this.isLimitedEval) {
                                if (this.shpoAgencyEvalIsDiff()) {
                                    this.checkSourceAndCreateEvaluation(evaluationService.EvaluationSourceEnum.Current)
                                } else {
                                }
                            }
                        }
                        break
                    default:
                        break
                    }
                } else {
                    this.log('creating new evaluation')
                    // create Initial evaluation
                    if (this.isInternalReview) {
                        var sourceEnum = this.currentWorkflowStatus.workflowStatusId <= this.crrWfsEnum.PendingAgencyApproval
                            ? evaluationService.EvaluationSourceEnum.Agency : evaluationService.EvaluationSourceEnum.SHPO
                        this.createEvaluation(sourceEnum)
                    // normalization
                    } else if (this.isNormalization) {
                        this.createEvaluation(evaluationService.EvaluationSourceEnum.SHPO)
                    } else {
                        this.createEvaluation(evaluationService.EvaluationSourceEnum.Consultant)
                    }
                }
                return response
            })
        },
        createEvaluation (evaluationSourceId) {
            var evaluationDto = {
                culturalResourceRecordingId: this.$route.params.culturalResourceRecordingId,
                isContributing: '',
                eligibilityId: '',
                effectId: '',
                evaluationSourceId: evaluationSourceId,
                associatedCulturalResourceId: this.head.culturalResourceId,
                sourceName: evaluationService.sourceName(evaluationSourceId)
            }
            //if creating Current Eval, copy over Justification from all other sources
            if (evaluationSourceId === evaluationService.EvaluationSourceEnum.Current) {
                evaluationDto.justification = this.createCurentEvalJustification()
            }
            if (this.canContribute) {
                this.log('found contributor, copy stuff from head')
                evaluationDto.eligibilityId = this.head.currentEval.eligibilityId
                evaluationDto.isEligibleA = this.head.currentEval.isEligibleA
                evaluationDto.isEligibleB = this.head.currentEval.isEligibleB
                evaluationDto.isEligibleC = this.head.currentEval.isEligibleC
                evaluationDto.isEligibleD = this.head.currentEval.isEligibleD
            }
            this.evaluationList.push(evaluationDto)
        },
        checkSourceAndCreateEvaluation (evaluationSourceId) {
            if ((this.currentUserEvaluationSourceEnum.includes(evaluationSourceId)) &&
            !(this.evaluationList.find(evaluation => { return evaluation.evaluationSourceId === evaluationSourceId }))) {
                this.createEvaluation(evaluationSourceId)
                // return true if new eval is created
                return true
            } else {
                // return false if no eval is created
                return false
            }
        },
        createCurentEvalJustification () {
            var conJust = (this.evaluationList.find(e => { return e.evaluationSourceId === evaluationService.EvaluationSourceEnum.Consultant }) || {}).justification
            var agencyJust = (this.evaluationList.find(e => { return e.evaluationSourceId === evaluationService.EvaluationSourceEnum.Agency }) || {}).justification
            var shpoJust = (this.evaluationList.find(e => { return e.evaluationSourceId === evaluationService.EvaluationSourceEnum.SHPO }) || {}).justification

            var currentJust = ''
            if (conJust) currentJust = 'Consultant: ' + conJust + '\n\n'
            if (agencyJust) currentJust = currentJust + 'Agency: ' + agencyJust + '\n\n'
            if (shpoJust) currentJust = currentJust + 'SHPO: ' + shpoJust + '\n\n'
            return currentJust
        },
        loadCurrentWorkflowStatus (crrId) {
            this.currentWorkflowStatus = {}
            var handle = this
            return workflowService.currentWorkflowStatusDto(handle.$http, workflowService.WorkflowEnum.CulturalResourceRecording, crrId)
                .then(function (response) {
                    handle.currentWorkflowStatus = response.data
                })
        },
        loadData () {
            var crrId = this.$route.params.culturalResourceRecordingId
            this.log(`Loading data. Head: ${this.head.culturalResourceId} CR: ${this.culturalResource.culturalResourceId}`)
            // load current workflowstatus first so its data can be used in latter calls
            return Promise.all([this.loadCurrentWorkflowStatus(crrId)]).then(response => {
                Promise.all([this.loadEvaluations(crrId)]).then(response2 => {
                    this.loadLookups()
                })
            })
        },
        buildView () {
            /*
            this.sourceSubmitStatus[1] = this.crrWfsEnum.PendingInvestigationSubmit
            this.sourceSubmitStatus[2] = this.crrWfsEnum.PendingAgencyApproval
            this.sourceSubmitStatus[3] = this.crrWfsEnum.PendingSHPOApproval
            this.sourceSubmitStatus[4] = this.crrWfsEnum.Concurrence // SHPO

            this.evaluationList.forEach(evaluation => {
                var submitStatusId = this.sourceSubmitStatus[evaluation.evaluationSourceId]
                var status = this.nextWorkflowStatusList.find(possibleStatus => {
                    return possibleStatus.workflowStatusId === submitStatusId
                })
                evaluation.canSubmit = (status)
                evaluation.canUpdate = evaluation.evaluationInstanceId > 0
                evaluation.sourceName = _.invert(evaluationService.EvaluationSourceEnum)[evaluation.evaluationSourceId]
            })
            */
        },
        loadLookups () {
            this.eligibilityTypeList = evaluationService.EligibilityTypeList
            this.effectList = evaluationService.EffectList
        },
        saveEligibility (evaluationSourceId) {
            this.$validator.validateAll().then(result => {
                if (result) {
                    // flag to see if we need to sapwn and save a Current eval (on initial SHPO eval save, if SHPO eval is the same as Agency Eval)
                    var spawnAndSaveCurrent = false

                    // if saving SHPO evaluation
                    if (evaluationSourceId === evaluationService.EvaluationSourceEnum.SHPO) {
                        // check SHPO and Agency Evals
                        if (this.shpoAgencyEvalIsDiff() && !this.isLimitedEval) {
                            // show confirmation to proceed
                            if (confirm('SHPO Evaluation is different from Agency Evaluation.  Are you sure you want to continue?')) {
                                // check for Current eval and create one if none
                                this.checkSourceAndCreateEvaluation(evaluationService.EvaluationSourceEnum.Current)
                            } else {
                                return
                            }
                        //else, SHPO and Agency evals are same, check if there's existing Current eval
                        } else {
                            var currentEval = this.evaluationList.find(evaluation => { return evaluation.evaluationSourceId === evaluationService.EvaluationSourceEnum.Current })
                            // if no Current eval or current eval hasn't been saved, set spawnAndSaveCurrent eval to true
                            spawnAndSaveCurrent = !this.isLimitedEval && (!currentEval || !currentEval.evaluationInstanceId || currentEval.evaluationInstanceId === 0)
                        }
                    }

                    var evaluation = this.evaluationList.find(e => { return e.evaluationSourceId === evaluationSourceId })
                    //data type fix for isContributing field
                    if (evaluation.isContributing === 'null') {
                        evaluation.isContributing = null
                    } else if (evaluation.isContributing === 'true') {
                        evaluation.isContributing = true
                    } else if (evaluation.isContributing === 'false') {
                        evaluation.isContributing = false
                    }
                    this.log('Save eligibility has been called for ' + evaluation.sourceName)
                    evaluationService.put(this.$http, evaluation).then(result => {
                        if (result.data.isValid) {
                            // if spawnCurrent is true, create Current eval using SHPO eval data and save eval
                            if (spawnAndSaveCurrent) {
                                //using JSON.stringify and JSON.parse to "copy" object without reference
                                var currentEval = this.copyEval(evaluationSourceId)
                                currentEval.justification = this.createCurentEvalJustification()
                                //SHPO Concurred
                                currentEval.concurredId = 1
                                //save current evaluation
                                this.log('Saving Curent eval')
                                evaluationService.put(this.$http, currentEval).then(result2 => {
                                    if (result.data.isValid) {
                                        this.log('Current eval is saved')
                                    }
                                })
                            }
                            this.onEvaluationSave().then(response => {
                                this.loadData()
                            })
                        } else {
                            this.log('evaluation is INVALID, showing errors')
                            this.validationResult = result.data
                        }
                    })
                } else {
                    this.log('submit - invalid form')
                }
            })
        },
        shpoAgencyEvalIsDiff () {
            // find the shpo and agency evaluations from evaluationList
            var shpoEval = this.evaluationList.find(e => { return e.evaluationSourceId === evaluationService.EvaluationSourceEnum.SHPO })
            var agencyEval = this.evaluationList.find(e => { return e.evaluationSourceId === evaluationService.EvaluationSourceEnum.Agency })
            //use consultant eval if agency eval is not found
            if (!agencyEval) {
                agencyEval = this.evaluationList.find(e => { return e.evaluationSourceId === evaluationService.EvaluationSourceEnum.Consultant })
            }

            // If both shpoEval and agencyEval exists, do check.  Else return true
            if (shpoEval && agencyEval) {
                // check if both evals are eligible
                if (shpoEval.eligibilityId === evaluationService.EligibilityEnum.Eligible && agencyEval.eligibilityId === evaluationService.EligibilityEnum.Eligible) {
                    //check the eligible fields
                    var checkEligA = Boolean(agencyEval.isEligibleA) !== Boolean(shpoEval.isEligibleA)
                    var checkEligB = Boolean(agencyEval.isEligibleB) !== Boolean(shpoEval.isEligibleB)
                    var checkEligC = Boolean(agencyEval.isEligibleC) !== Boolean(shpoEval.isEligibleC)
                    var checkEligD = Boolean(agencyEval.isEligibleD) !== Boolean(shpoEval.isEligibleD)
                    var checkEffectId = agencyEval.effectId !== shpoEval.effectId
                    return checkEligA || checkEligB || checkEligC || checkEligD || checkEffectId
                } else {
                    // only check if eligibilityIds are the same if both are not eligible
                    return shpoEval.eligibilityId !== agencyEval.eligibilityId
                }
            } else {
                return false
            }
        },
        evalValidationRules (evalSourceId) {
            var expression = {
                rules: { required: true }
            }
            // set required to false on Current eval if shpo and agency evals are not different
            if (evalSourceId === evaluationService.EvaluationSourceEnum.Current && !this.shpoAgencyEvalIsDiff()) {
                expression.rules.required = false
            }
            return expression
        },
        copyEval (evalSourceId) {
            var evaluation = this.evaluationList.find(e => { return e.evaluationSourceId === evalSourceId })
            if (!evaluation) return null
            //using JSON.stringify and JSON.parse to "copy" object without reference
            var newEval = JSON.parse(JSON.stringify(evaluation))
            newEval.evaluationSourceId = evaluationService.EvaluationSourceEnum.Current
            newEval.sourceName = evaluationService.sourceName(evaluationService.EvaluationSourceEnum.Current)
            newEval.evaluationInstanceId = 0
            return newEval
        }
    }
}
</script>

<style>
    .inline {
        display: inline;
    }
</style>



// WEBPACK FOOTER //
// siteEvaluation.vue?f64ad650